import gql from "graphql-tag";

export const FORGOT_PASSWORD = gql`
    mutation userResetPassword(
        $resetPasswordToken: String!
        $newPassword: String!
      ) {
        userResetPassword(
          input: {
            resetPasswordToken: $resetPasswordToken
            newPassword: $newPassword
          }
        ) {
          success
          message
        }
      }
`;
